<form [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (etatPush === undefined || etatPush === "loading") {
    @if (patient && this.prescription?.type == "prolongation") {
      <div tuiAppearance="floating" tuiCardLarge>
        <h2>Informations renouvellement</h2>
        <section>
          <label tuiLabel>Renouvellement *</label>
          <div tuiGroup [collapsed]="true">
            <label tuiBlock>
              à 4 mois
              <input
                formControlName="ppcTypeSlug"
                tuiRadio
                type="radio"
                value="dap_4mois"
                [style.margin-left]="'auto'"
              />
            </label>
            <label tuiBlock>
              annuel
              <input
                formControlName="ppcTypeSlug"
                tuiRadio
                type="radio"
                value="dap_annuel"
                [style.margin-left]="'auto'"
              />
            </label>
          </div>
          <tui-error
            formControlName="ppcTypeSlug"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <label tuiLabel>
          Soins en rapport avec une ALD
          <input formControlName="ald" tuiSwitch type="checkbox" />
        </label>
        <tui-textfield>
          <label tuiLabel>IAH sous traitement</label>
          <input formControlName="renouvellementIah" tuiTextfield />
          <tui-error
            formControlName="renouvellementIah"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <label tuiLabel>
          Amélioration de la symptomatologie
          <input
            formControlName="renouvellementAmeliorationSymptomatologie"
            tuiSwitch
            type="checkbox"
          />
        </label>
        <label tuiLabel>
          Patient observant
          <input
            formControlName="renouvellementPatientObservant"
            tuiSwitch
            type="checkbox"
          />
        </label>
      </div>
    } @else {
      <div tuiAppearance="floating" tuiCardLarge>
        <h2>Informations patient</h2>
        <tui-textfield>
          <label tuiLabel>Nom *</label>
          <input formControlName="nom" tuiTextfield />
          <tui-error
            formControlName="nom"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Prénom *</label>
          <input formControlName="prenom" tuiTextfield />
          <tui-error
            formControlName="prenom"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <section>
          <label tuiLabel>Sexe *</label>
          <div tuiGroup [collapsed]="true" id="sexe">
            <label tuiBlock>
              Homme
              <input
                formControlName="sexe"
                tuiRadio
                type="radio"
                value="homme"
                [style.margin-left]="'auto'"
              />
            </label>
            <label tuiBlock>
              Femme
              <input
                formControlName="sexe"
                tuiRadio
                type="radio"
                value="femme"
                [style.margin-left]="'auto'"
              />
            </label>
          </div>
          <tui-error
            formControlName="sexe"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <section id="date-de-naissance">
          <tui-input-date formControlName="dateDeNaissance">
            Date de naissance *
          </tui-input-date>
          <tui-error
            formControlName="dateDeNaissance"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <tui-textfield id="nir">
          <label tuiLabel>NIR *</label>
          <input formControlName="nir" tuiTextfield />
          <tui-error
            formControlName="nir"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Adresse</label>
          <input formControlName="adresseLigne1" tuiTextfield />
          <tui-error
            formControlName="adresseLigne1"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Adresse complément</label>
          <input formControlName="adresseLigne2" tuiTextfield />
          <tui-error
            formControlName="adresseLigne2"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <section id="code-postal-et-ville">
          <tui-textfield>
            <label tuiLabel>Code postal</label>
            <input formControlName="adresseCodePostal" tuiTextfield />
            <tui-error
              formControlName="adresseCodePostal"
              [error]="[] | tuiFieldError | async"
            />
          </tui-textfield>
          <tui-textfield>
            <label tuiLabel>Ville</label>
            <input formControlName="adresseVille" tuiTextfield />
            <tui-error
              formControlName="adresseVille"
              [error]="[] | tuiFieldError | async"
            />
          </tui-textfield>
        </section>
        <tui-textfield id="telephone">
          <label tuiLabel>Numéro de téléphone *</label>
          <input formControlName="telephone" tuiTextfield />
          <tui-error
            formControlName="telephone"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Nom de la caisse</label>
          <input formControlName="caisseNom" tuiTextfield />
          <tui-error
            formControlName="caisseNom"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Numéro de la caisse</label>
          <input formControlName="caisseNumero" tuiTextfield />
          <tui-error
            formControlName="caisseNumero"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
      </div>
      <div tuiAppearance="floating" tuiCardLarge>
        <h2>Traitement prescrit</h2>
        <label tuiLabel>
          Soins en rapport avec une ALD
          <input formControlName="ald" tuiSwitch type="checkbox" />
        </label>
        <section>
          <label tuiLabel>Type d'appareil</label>
          <div class="radioList">
            <label tuiLabel>
              <input
                name="test"
                tuiRadio
                type="radio"
                value="autopilotee"
                formControlName="ppcAppareilType"
              />
              Autopilotée
            </label>
            <label tuiLabel>
              <input
                name="test"
                tuiRadio
                type="radio"
                value="a_pression_fixe"
                formControlName="ppcAppareilType"
              />
              À pression fixe
            </label>
            <label tuiLabel>
              <input
                name="test"
                tuiRadio
                type="radio"
                value="a_double_niveau_de_pression"
                formControlName="ppcAppareilType"
              />
              À double niveau de pression
            </label>
          </div>
          <tui-error
            formControlName="ppcAppareilType"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <tui-textfield>
          <label tuiLabel>Pression ou intervalle de pression (cm H2O)</label>
          <input formControlName="ppcPression" tuiTextfield />
          <tui-error
            formControlName="ppcPression"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Réglage particulier</label>
          <input formControlName="reglage" tuiTextfield />
          <tui-error
            formControlName="reglage"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <section>
          <tui-textarea formControlName="ppcInterfaceType" [expandable]="true">
            Type d'interface
          </tui-textarea>
          <tui-error
            formControlName="ppcInterfaceType"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <tui-textfield>
          <label tuiLabel>Marque et modèle</label>
          <input formControlName="ppcModeleMarque" tuiTextfield />
          <tui-error
            formControlName="ppcModeleMarque"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
      </div>
      <div tuiAppearance="floating" tuiCardLarge>
        <h2>Eléments d’ordre médical</h2>
        <section>
          <h3>Symptômes cliniques (minimum 1)</h3>
          <tui-error
            formControlName="nombreSymptomesCoches"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <label tuiLabel>
          Somnolence diurne
          <input formControlName="somnolenceDiurne" tuiSwitch type="checkbox" />
        </label>
        <label tuiLabel>
          Ronflements sévères et quotidiens
          <input
            formControlName="ronflementsSeveres"
            tuiSwitch
            type="checkbox"
          />
        </label>
        <label tuiLabel>
          Céphalées matinales
          <input
            formControlName="cephaleesMatinales"
            tuiSwitch
            type="checkbox"
          />
        </label>
        <label tuiLabel>
          Fatigue diurne
          <input formControlName="fatigueDiurne" tuiSwitch type="checkbox" />
        </label>
        <label tuiLabel>
          Nycturie
          <input formControlName="nycturie" tuiSwitch type="checkbox" />
        </label>
        <label tuiLabel>
          Sensation d’étouffement ou de suffocation pendant le sommeil
          <input
            formControlName="sensationEtouffement"
            tuiSwitch
            type="checkbox"
          />
        </label>
        <section>
          <h3>Pathologies</h3>
        </section>
        <label tuiLabel>
          Somnolence diurne sévère et/ou risque accidentel
          <input
            formControlName="somnolenceDiurneSevereRisqueAccidentel"
            tuiSwitch
            type="checkbox"
          />
        </label>
        <section>
          <label tuiLabel>
            Comorbidité cardio-vasculaire associée grave
            <input
              formControlName="comorbiditeCardioVasculaireGrave"
              tuiSwitch
              type="checkbox"
            />
          </label>
          @if (this.form.get("comorbiditeCardioVasculaireGrave")?.value) {
            <tui-textfield>
              <label tuiLabel
                >Précision comorbidité cardio-vasculaire associée grave</label
              >
              <input
                formControlName="initialeComorbiditeCardioVasculaireAssocieeGraveMotif"
                tuiTextfield
              />
              <tui-error
                formControlName="initialeComorbiditeCardioVasculaireAssocieeGraveMotif"
                [error]="[] | tuiFieldError | async"
              />
            </tui-textfield>
          }
        </section>
        <section>
          <label tuiLabel>
            Comorbidité respiratoire associée grave
            <input
              formControlName="comorbiditeRespiratoireGrave"
              tuiSwitch
              type="checkbox"
            />
          </label>
          @if (this.form.get("comorbiditeRespiratoireGrave")?.value) {
            <tui-textfield>
              <label tuiLabel
                >Précision comorbidité respiratoire associée grave</label
              >
              <input
                formControlName="initialeComorbiditeRespiratoireAssocieeGraveMotif"
                tuiTextfield
              />
              <tui-error
                formControlName="initialeComorbiditeRespiratoireAssocieeGraveMotif"
                [error]="[] | tuiFieldError | async"
              />
            </tui-textfield>
          }
        </section>
        <section>
          <label tuiLabel>Examen réalisé *</label>
          <div tuiGroup [collapsed]="true" id="examen-realise">
            <label tuiBlock>
              Polygraphie
              <input
                formControlName="examenRealise"
                tuiRadio
                type="radio"
                value="polygraphie"
                [style.margin-left]="'auto'"
                (onChange)="updateMicroEveils()"
              />
            </label>
            <label tuiBlock>
              Polysomnographie
              <input
                formControlName="examenRealise"
                tuiRadio
                type="radio"
                value="polysomnographie"
                [style.margin-left]="'auto'"
                (onChange)="updateMicroEveils()"
              />
            </label>
          </div>
          <tui-error
            formControlName="examenRealise"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        @if (this.form.get("examenRealise")?.value == "polysomnographie") {
          <tui-textfield>
            <label tuiLabel
              >Micro éveils
              {{
                authService.getUser()?.role?.slug == "liberal" ? "*" : ""
              }}</label
            >
            <input formControlName="microEveils" tuiTextfield />
            <tui-error
              formControlName="microEveils"
              [error]="[] | tuiFieldError | async"
            />
          </tui-textfield>
        }
        <section>
          <label tuiLabel>IAH/h *</label>
          <div tuiGroup [collapsed]="true">
            <label tuiBlock>
              ≤ 15
              <input
                formControlName="iahGap"
                tuiRadio
                type="radio"
                value="lt15"
                [style.margin-left]="'auto'"
              />
            </label>
            <label tuiBlock>
              > 15 et < 30
              <input
                formControlName="iahGap"
                tuiRadio
                type="radio"
                value="gt15_lt30"
                [style.margin-left]="'auto'"
              />
            </label>
            <label tuiBlock>
              ≥ 30
              <input
                formControlName="iahGap"
                tuiRadio
                type="radio"
                value="gt30"
                [style.margin-left]="'auto'"
              />
            </label>
          </div>
          <tui-error
            formControlName="iahGap"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        @if (this.form.get("typeSlug")?.value == "ppc_ordoclic") {
          <section>
            @if (
              this.form.get("iahGap")?.value == "gt15_lt30" &&
              this.form.get("nombreSymptomesCoches")?.value >= 3 &&
              this.form.get("nombrePathologiesCoches")?.value == 0
            ) {
              <tui-textarea
                #textarea
                formControlName="commentaire"
                class="tui-space_top-4"
                [expandable]="textarea.focused"
              >
                Commentaires
              </tui-textarea>
            } @else {
              <p>Commentaires disponible si :</p>
              <ul>
                <li>&nbsp;• IAH entre 15 et 30</li>
                <li>&nbsp;• Au moins 3 symptômes cliniques</li>
                <li>&nbsp;• Aucune pathologie</li>
              </ul>
            }
          </section>
        }
        <section>
          <label tuiLabel class="tui-row_align_center"
            >Compte-rendu (max 5Mo, PDF)
            @if (authService.user?.role?.slug == "liberal") {
              *
            }
          </label>
          @if (!form.get("compteRendu")?.value) {
            <label tuiInputFiles>
              <input
                tuiInputFiles
                accept="application/pdf"
                [maxFileSize]="5500000"
                formControlName="compteRendu"
              />
            </label>
          }
          <tui-files class="tui-space_top-1">
            @if (
              form.get("compteRendu")?.value
                | tuiFileRejected: { accept: "application/pdf" }
                | async;
              as file
            ) {
              <tui-file state="error" [file]="file!" (remove)="removeFile()" />
            }
            @if (loadedFiles$ | async; as file) {
              <tui-file [file]="file!" (remove)="removeFile()" />
            }
            @if (failedFiles$ | async; as file) {
              <tui-file state="error" [file]="file!" (remove)="removeFile()" />
            }
            @if (loadingFiles$ | async; as file) {
              <tui-file
                state="loading"
                [file]="file!"
                (remove)="removeFile()"
              />
            }
          </tui-files>
          <tui-error
            formControlName="compteRendu"
            [error]="[] | tuiFieldError | async"
          />
        </section>
      </div>
    }
    <div tuiAppearance="floating" tuiCardLarge>
      <h2>Signature</h2>
      <section id="date-de-prescription">
        <tui-input-date formControlName="dateDePrescription">
          Date de prescription *
        </tui-input-date>
        <tui-error
          formControlName="dateDePrescription"
          [error]="[] | tuiFieldError | async"
        />
      </section>
      @if (typeSlug == "ppc_ordoclic") {
        <div id="text-ordoclic" class="tui-text_bold">
          NB: Pour transmettre la DAP, vous devez être en possession de votre
          carte CPS ou avoir accès à l'application eCPS.
        </div>
        <div>
          <a
            href="https://apps.apple.com/us/app/e-cps/id1469033607"
            target="_blank"
            rel="noopener"
            ><img
              src="../../../assets/images/Logo-App-store.png"
              alt=""
              loading="lazy"
              width="130"
          /></a>
          <a
            href="https://play.google.com/store/apps/details?id=fr.asipsante.esante.wallet.prod&amp;hl=fr"
            target="_blank"
            rel="noopener"
            ><img
              src="../../../assets/images/Logo-Google-play.png"
              alt=""
              loading="lazy"
              width="130"
          /></a>
        </div>
        <div id="boutonEnregistrer">
          <button tuiButton type="submit" [disabled]="etatPush === 'loading'">
            Editer et e-signer
          </button>
        </div>
      } @else {
        <section>
          <div tuiGroup [collapsed]="true">
            @if (
              patient?.canSign || (!patient && authService.getUser()?.rpps)
            ) {
              <label tuiBlock (click)="selectMe()">
                Signer en mon nom
                <input
                  formControlName="aSigner"
                  tuiRadio
                  type="radio"
                  [value]="true"
                  [style.margin-left]="'auto'"
                />
              </label>
            }
            <label tuiBlock>
              Préparer au nom de
              <input
                formControlName="aSigner"
                tuiRadio
                type="radio"
                [value]="false"
                [style.margin-left]="'auto'"
              />
            </label>
          </div>
          <tui-error
            formControlName="aSigner"
            [error]="[] | tuiFieldError | async"
          />
        </section>

        @if (this.form.get("aSigner")?.value == false) {
          <section>
            <tui-combo-box formControlName="medecin">
              Préparer au nom de
              <tui-data-list-wrapper
                *tuiDataList
                [items]="userList | tuiFilterByInput: matcherString"
              />
            </tui-combo-box>
            <tui-error
              formControlName="medecin"
              [error]="[] | tuiFieldError | async"
            />
          </section>
        }

        <div id="boutonEnregistrer">
          @if (this.form.get("aSigner")?.value) {
            <button tuiButton type="submit" [disabled]="etatPush === 'loading'">
              Editer et e-signer
            </button>
          } @else {
            <button
              tuiButton
              appearance="outline"
              tuiAppearanceMode="checked"
              type="submit"
              [disabled]="etatPush === 'loading'"
            >
              Editer sans e-signature
            </button>
          }
        </div>
      }
    </div>
  } @else if (etatPush) {
    <div tuiAppearance="floating" tuiCardLarge class="statut-card">
      <tui-avatar
        appearance="positive"
        src="@tui.badge-check"
        tuiAnimated
        id="avatar-check"
      />
      <div tuiAnimated>
        Prescription éditée avec succès !
        @if (this.form.get("aSigner")?.value) {
          <br />
          <i
            >(signature électronique en cours, disponible dans quelques
            minutes)</i
          >
        }
      </div>
    </div>
  } @else {
    <div tuiAppearance="floating" tuiCardLarge class="statut-card">
      <tui-avatar appearance="error" src="@tui.badge-alert" tuiAnimated />
      <div tuiAnimated>Une erreur est survenue</div>
      <div id="boutonReessayer">
        <button
          tuiButton
          appearance="outline"
          tuiAppearanceMode="checked"
          (click)="initEtatPush()"
        >
          Réessayer
        </button>
      </div>
    </div>
  }
</form>

<dialog id="ordoclic-amelipro-dialog">
  <button id="close-dialog-button" (click)="closeDialog()">×</button>
  <iframe id="ordoclic-amelipro-iframe"></iframe>
</dialog>
